import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

export type useQueryFilterType = {
  params: Record<string, string | null | undefined>;
  updateParams: (key: string, value: unknown) => void;
  clearParams: () => void;
  searchParams: URLSearchParams;
  clearParam: (key: string) => void;
};

export const useQueryFilter = (...keys: string[]): useQueryFilterType => {
  const [searchParams, setSearchParams] = useSearchParams();

  // const [isClear, setIsClear]= useState(false)
  const [params, setParams] = useState(
    keys?.reduce(
      (acc, key) => {
        acc[key] = "";

        return acc;
      },
      {} as Record<string, string | null | undefined>,
    ),
  );

  const clearParams = (): void => {
    setParams(
      keys?.reduce(
        (acc, key) => {
          acc[key] = null;

          return acc;
        },
        {} as Record<string, string | null | undefined>,
      ),
    );
  };

  const clearParam = (key: string): void => {
    setParams((prev) => {
      const newParams = { ...prev };
      newParams[key] = null;

      return newParams;
    });
  };

  const updateParams = (key: string, value: unknown): void => {
    if (value === "") {
      setParams((prev) => {
        const newParams = { ...prev };
        newParams[key] = null;

        return newParams;
      });
    } else {
      setParams((prev) => ({
        ...prev,
        [key]: value === "" ? undefined : (value as string),
      }));
    }
  };

  useEffect(() => {
    // if (!isClear) {
    const newParams = keys?.reduce(
      (acc, key) => {
        const paramValue = params[key] ?? "";

        if (searchParams.get(key) || paramValue) {
          if (params[key]) {
            acc[key] = paramValue;
          }
        }

        return acc;
      },
      {} as Record<string, string>,
    );

    const currentParams: {
      [key: string]: string | string[];
    } = {};
    searchParams?.forEach((_, key) => {
      if (params[key] !== null) {
        const all = searchParams.getAll(key);
        currentParams[key] = params[key] || all;
      }
    });
    setSearchParams({
      ...newParams,
      ...currentParams,
    });
    // }
    // setIsClear(false)
  }, [params, searchParams]);

  return { params, updateParams, clearParams, searchParams, clearParam };
};

export default useQueryFilter;
